import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface DuplicateManualThreadParams {
  matterId: string;
  subsetId: string;
  threadId: string;
}

interface DuplicateManualThreadResponse {
  threadId: string;
  userMessageId: string;
  assistantMessageId: string;
}

export const useDuplicateManualThread = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<DuplicateManualThreadResponse, Error, DuplicateManualThreadParams>(
    async (params) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${params.matterId}/subset/${params.subsetId}/thread/${params.threadId}/duplicate`,
        fetchConfig,
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to duplicate manual thread');
      }

      return response.json();
    },
    {
      onSuccess: (data, variables) => {
        // Invalidate threads query to refresh list
        queryClient.invalidateQueries([QueryEntity.Threads, { subsetId: variables.subsetId }]);
      },
    },
  );
};
